"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Copyright (c) 2015-present, Zippy Technologies
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var dblTouchTapMaxDelay = 300;
var latestTouchTap = {
  time: 0,
  target: null
};

function isEventDoubleTap(event) {
  var touchTap = {
    time: new Date().getTime(),
    target: event.currentTarget
  };
  var isFastDblTouchTap = touchTap.target === latestTouchTap.target && touchTap.time - latestTouchTap.time < dblTouchTapMaxDelay;
  latestTouchTap = touchTap;
  return isFastDblTouchTap;
}

exports.default = isEventDoubleTap;